import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { DeactivateYourAccountSchema } from '../../../schemas';
import { ErrorButton, SecondaryButton } from "../../UI";
import { deactivateUser } from '../../../utils/APIs';
import { useUserContext } from '../../../contexts/UserContext';
import { toast } from 'react-toastify';
import { useAuth0 } from '@auth0/auth0-react';
import Loader from '../Loader/Loader';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const DeactivateYourAccountForm = ({ submitHandler, handleCancelClick }) => {
    const { userData } = useUserContext();
    const { enums, content } = useContentfulContext();

    const { logout } = useAuth0();
    const [loading, setLoading] = useState(false);

    const handleDeactivateUser = async () => {
        setLoading(true);
        const result = await deactivateUser(userData.token, userData?.user_id, userData?.selectedOrganization?.org_token, true);
        if (result.status) {
            setLoading(false);
            toast.success(result.message);
            logout({
                logoutParams: { returnTo: enums?.LOGOUT_REDIRECT_URL },
            });
        } else {
            setLoading(false);
            toast.error(result.message);
        }
    };

    return (
        <>
            {loading && <Loader />}
            <Formik
                initialValues={{
                    password: '',
                }}
                validationSchema={() => DeactivateYourAccountSchema(content.DEACTIVATE_YOUR_ACCOUNT)}
                onSubmit={async () => {
                    if (typeof submitHandler === 'function') {
                        submitHandler();
                    }
                }}
            >
                {() => (
                    <Form className="space-y-4 md:space-y-6" action="#">
                        <div className="pb-4 space-x-4 flex">
                            <ErrorButton disable={loading} handleClick={handleDeactivateUser}>
                                {content.DEACTIVATE_YOUR_ACCOUNT.formLabels.submit_text}
                            </ErrorButton>
                            <SecondaryButton handleClick={handleCancelClick}>
                                {content.DEACTIVATE_YOUR_ACCOUNT.formLabels.cancel_text}
                            </SecondaryButton>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default DeactivateYourAccountForm;
